import { AxiosError } from 'axios';

import { URL_CONSTANTS } from '../../../constants/urlConstants';
import apiService from '../../../services/api.service';

export const fetchFeatureDataByModule = async (module: string) => {
  try {
    const response = await apiService.get(
      apiService.formatUrl(
        URL_CONSTANTS.HELP_PAGE_CONFIG.featureWithModule,
        module
      )
    );

    if (response?.status)
      return {
        error: false,
        message: 'Feature data fetched successfully.',
        data: response?.data,
      };
  } catch (error: unknown) {
    console.error('Error fetching Feature data', error);
    return {
      error: true,
      message:
        error instanceof AxiosError
          ? error?.response?.data?.error
          : 'Error fetching Feature data',
      data: {},
    };
  }
};
